export default __webpack_public_path__ + "static/media/featured_area_ajax.975cf9ea.webp";